import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  EQUIPMENT_LIST,
  EQUIPMENT_ADD,
  EQUIPMENT_DETAIL,
  EQUIPMENT_UPDATE
} from '../../actions';

import {
  EquipmentListSuccess,
  EquipmentListError,
  EquipmentAddSuccess,
  EquipmentAddError,
  EquipmentDetailSuccess,
  EquipmentDetailError,
  EquipmentUpdateSuccess,
  EquipmentUpdateError
} from '../../actions';
 
export function* watchEquipmentList() {
  yield takeEvery(EQUIPMENT_LIST, onEquipmentList);
}

export function* watchEquipmentAdd() {
  yield takeEvery(EQUIPMENT_ADD, onEquipmentAdd);
}

export function* watchEquipmentDetail() {
  yield takeEvery(EQUIPMENT_DETAIL, onEquipmentDetail);
}

export function* watchEquipmentUpdate() {
  yield takeEvery(EQUIPMENT_UPDATE, onEquipmentUpdate);
}

const onEquipmentListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEquipmentAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEquipmentDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onEquipmentList(data) {
  try {
    const response = yield call(onEquipmentListAsync, data.payload);
    yield put(EquipmentListSuccess(response.data));
  } catch (error) {
    yield put(EquipmentListError(error));
  }
}

function* onEquipmentAdd(data) {
  try {
      const response = yield call(onEquipmentAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EquipmentAddSuccess(response.data));
  } catch (error) {
      yield put(EquipmentAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEquipmentDetail(data) {
  try {
    const response = yield call(onEquipmentDetailAsync, data.payload);
    yield put(EquipmentDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EquipmentDetailError(error));
  }
}

function* onEquipmentUpdate(data) {
  try {
      const response = yield call(onEquipmentUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EquipmentUpdateSuccess(response.data));
  } catch (error) {
      yield put(EquipmentUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEquipmentList),
    fork(watchEquipmentAdd),
    fork(watchEquipmentDetail),
    fork(watchEquipmentUpdate),
  ]);
} 